// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_container_profile__2jzoP {
  display: flex;
  flex-direction: column;
  align-items:flex-start;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}

.profile_profile_progress__xq1QN {
  width: 33%;
    margin-top: 2rem;
    margin-left: auto;
    margin-right: auto;
}

.profile_profile_content__WW6vo {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 1450px;
  margin-top: 2rem;
  gap: 1rem;
  /* Add spacing between child elements */
}

.profile_profile_content__WW6vo > * {
  flex: 0 0 48%;
  max-width: 700px;
}

@media (max-width: 768px) {
  .profile_profile_content__WW6vo {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .profile_profile_content__WW6vo > * {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/Profile/profile.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;IACR,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container_profile {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items:flex-start;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.profile_progress {\r\n  width: 33%;\r\n    margin-top: 2rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.profile_content {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  width: 100%;\r\n  max-width: 1450px;\r\n  margin-top: 2rem;\r\n  gap: 1rem;\r\n  /* Add spacing between child elements */\r\n}\r\n\r\n.profile_content > * {\r\n  flex: 0 0 48%;\r\n  max-width: 700px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .profile_content {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .profile_content > * {\r\n    max-width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_profile": `profile_container_profile__2jzoP`,
	"profile_progress": `profile_profile_progress__xq1QN`,
	"profile_content": `profile_profile_content__WW6vo`
};
export default ___CSS_LOADER_EXPORT___;
